<template>
  <div id="recbuydri">
    <div
      style="display: none; padding: 0px"
      id="recbuydri-content"
      data-padding="0"
    >
      <div
        class="nr-mem-recbuydri"
        style="width: 100%; height: 600px; background: unset"
      >
        <div class="center">
          <div class="ctnr">
            <div class="r-content">
              <ul>
                <li v-for="(item, index) in aryDet" :key="index">
                  <div>
                    <img :src="item.img" alt="" />
                  </div>
                  <div>
                    <span>{{ item.name }}</span>
                    <span> {{ item.price }}</span>
                    <span> 數量 : {{ item.qty }} </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nr">
      <CompMarquee />
      <div class="center">
        <div class="ctnr">
          <h3>直購商品記錄</h3>
          <ul>
            <li v-if="!recordList.length" class="noData">無紀錄</li>
            <li
              v-for="(item, index) in recordList"
              :key="index"
              @click="vodDetail(item.items)"
            >
              <div class="p1">
                <div class="l">
                  <span>{{ item.single_number }}</span>
                </div>
                <div class="r" v-text="item.goods_status"></div>
              </div>
              <div class="p2">
                <strong
                  class="cy"
                  v-if="item.amount.indexOf('新台幣') !== -1"
                  >{{ item.amount | cleanDotFilter }}</strong
                >
                <strong class="cy" v-else>
                  <div>
                    {{ item.amount.substr(0, item.amount.indexOf(",")) }}
                  </div>
                  <div>
                    {{ item.amount.substr(item.amount.indexOf(",") + 1) }}
                  </div>
                </strong>
              </div>
              <div class="p2">
                <strong v-if="item.logistics_name"
                  >快遞 : {{ item.logistics_name }}</strong
                >
                <strong class="w" v-if="item.logistics_number"
                  >快遞編號 : {{ item.logistics_number }}</strong
                >
              </div>
              <div class="p3">
                <p>訂單日期 : {{ item.under_at | date }}</p>
                <p v-if="item.shipment_at">出貨日期 : {{ item.shipment_at }}</p>
              </div>
            </li>
          </ul>
          <CompPager
            @evtpagerchg="vodGetPage"
            :int-per-page="page.pagesize"
            :int-tol-cnt="pageData.allnums"
            :int-cur-page="page.currentPage"
            ref="pager"
          ></CompPager>
        </div>
      </div>
      <CompFoot/>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {
    CompMarquee: require("@/components/parts/Marquee").default,
    CompFoot: require("@/components/parts/Foot").default,
    CompPager: require("@/components/parts/pager").default,
    CompMenNavmem: require("@/components/parts/Navmem").default,
  },
  computed: {
    ...mapState({
      pageData: (state) => state.app.pageData,
      recordList: (state) => state.directpurchase.recordList,
    }),
  },
  data() {
    return {
      page: {
        pagesize: 10,
        currentPage: 1,
      },
      //
      aryDet: [],
      aryList: [],
      intTolCnt: 0,
      intPerPage: 10,
      intCurPage: 1,
      processStatus: {
        0: "未付款",
        1: "未出貨",
        2: "已出貨",
        3: "退貨中",
        4: "換貨中",
        5: "已送達",
        6: "完成交易",
        7: "取消交易",
      },
    };
  },
  methods: {
    vodGetPage(page) {
      this.page.currentPage = page;
      this.getRecord();
    },
    async getRecord() {
      const data = {
        page: this.page.currentPage,
        pagesize: this.page.pagesize,
        token: sessionStorage.token,
      };
      await this.$store.dispatch("directpurchase/record", data);
    },
    //
    vodDetail(items) {
      this.aryDet = items;
      $.fancybox.open({
        src: "#recbuydri-content",
        type: "inline",
        opts: {},
      });
    },
  },

  async mounted() {
    await this.getRecord();
  },
};
</script>
<style scoped>
@import "~@/assets/css/recbuydri.css";
</style>
